import Request from './request';

async function fetch(data) {// 获取优惠券一览
    return Request('get', "api/purchase-tasks/index", data);
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/purchase-tasks/view/" + id, data);
}

async function complete(data) {
    return Request('post', "api/purchase-tasks/complete", data);
}

async function fetchRelations(id, data) {
    // 获取相关单据
    return Request('get', 'api/purchase-tasks/' + id + '/relations', data)
}

export default {
    fetch,
    fetchOne,
    complete,
    fetchRelations,
};